var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "keywords",
    class: {
      'adjust-container': _vm.isFullScreenView && !_vm.$vuetify.breakpoint.xsOnly
    }
  }, [_c('v-row', {
    staticClass: "keywords-head-options",
    class: {
      'px-0 pt-0 px-sm-10 pt-sm-10': !_vm.isFullScreenView
    },
    attrs: {
      "no-gutters": ""
    }
  }, [_vm.isOnboarding ? _c('v-col', {
    staticClass: "col-auto pb-2 pr-2 d-flex align-center"
  }, [_c('ph-caret-left', {
    staticClass: "clickable grey--text text--lighten-1",
    attrs: {
      "weight": "light",
      "size": "24"
    },
    on: {
      "click": _vm.goBackToWelcomeSteps
    }
  })], 1) : _vm._e(), _vm.isOnboarding ? _c('v-col', {
    staticClass: "col-8 pb-2 text-left"
  }, [_c('h6', {
    staticClass: "text text-l-large-bold grey--text text--darken-1 clickable",
    on: {
      "click": _vm.goBackToWelcomeSteps
    }
  }, [_vm._v(" Back to Specialties ")])]) : _vm._e(), _vm.isGuestUser && !_vm.$vuetify.breakpoint.xsOnly ? _c('v-col', {
    staticClass: "col-8 pb-2 text-left"
  }, [_c('h6', {
    staticClass: "text text-l-large-bold grey--text text--darken-1"
  }, [_vm._v("Select interests")])]) : _vm._e(), _vm.isGuestUser && !_vm.$vuetify.breakpoint.xsOnly ? _c('v-col', {
    staticClass: "col-4 d-flex align-center justify-end"
  }, [_c('ph-x', {
    staticClass: "clickable grey--text text--lighten-1 close-icon-position",
    attrs: {
      "weight": "thin",
      "size": "32"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('close');
      }
    }
  })], 1) : _vm._e(), _c('v-col', {
    class: {
      'pt-4 pt-sm-0': _vm.isFullScreenView
    },
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "text grey--text text--darken-1 mb-0",
    class: _vm.$vuetify.breakpoint.width < 375 ? 'text-l-small-regular' : 'text-l-large-regular'
  }, [_vm._v(" Select any specific interests you may have to obtain better article recommendations. ")])]), _c('v-col', {
    staticClass: "col-12 pt-4"
  }, [_c('v-text-field', {
    staticClass: "keywords-search",
    attrs: {
      "solo": "",
      "height": "54px",
      "hide-details": "",
      "placeholder": "Search interest"
    },
    scopedSlots: _vm._u([{
      key: "prepend-inner",
      fn: function () {
        return [_c('ph-magnifying-glass', {
          staticClass: "grey--text text--lighten-2 mr-2",
          attrs: {
            "weight": "thin",
            "size": "24"
          }
        })];
      },
      proxy: true
    }]),
    model: {
      value: _vm.search,
      callback: function ($$v) {
        _vm.search = $$v;
      },
      expression: "search"
    }
  })], 1)], 1), _c('div', {
    staticClass: "keywords-container"
  }, [_c('v-row', {
    staticClass: "justify-center mx-0 mx-sm-0",
    class: {
      'chips-container': !_vm.isFullScreenView
    },
    attrs: {
      "no-gutters": ""
    }
  }, [_vm.loadingKeywords ? _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('ProgressBarComponent', {
    attrs: {
      "title": 'Keywords'
    }
  })], 1) : _vm._e(), _c('v-col', {
    staticClass: "px-0 pt-0",
    attrs: {
      "cols": "12"
    }
  }, [!_vm.loadingKeywords ? _c('v-row', {
    staticClass: "max-height",
    attrs: {
      "dense": "",
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "max-height mb-10 mb-sm-0",
    attrs: {
      "cols": "12"
    }
  }, [_vm.keywordsToDisplay.length > 0 ? _c('div', {
    staticClass: "text-left mt-0 py-1 px-1 mb-15 mb-sm-0"
  }, [_vm._l(_vm.keywordsToDisplay, function (keyword) {
    return _c('KeywordChipComponent', {
      key: keyword + _vm.uniqueKeysHelper(),
      attrs: {
        "keyword": keyword,
        "user-keywords": _vm.userKeywords,
        "is-big-mode": true
      },
      on: {
        "subscribe-keyword": _vm.handleSubscribeToKeyword,
        "unsubscribe-keyword": _vm.handleUnsubscribeToKeyword
      }
    });
  }), !_vm.loadingKeywords && _vm.loadingMoreKeywords ? _c('div', [_c('v-col', {
    staticClass: "text-center mobile pb-10",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1)], 1) : _vm._e()], 2) : _vm._e(), _vm.search && _vm.keywordsToDisplay.length === 0 ? _c('div', {
    staticClass: "no-keywords-found-container",
    class: _vm.$vuetify.breakpoint.height <= 470 ? 'align-start' : 'align-center'
  }, [_c('div', {
    staticClass: "row justify-center",
    class: {
      'mb-15': _vm.$vuetify.breakpoint.height <= 568
    }
  }, [_c('div', {
    staticClass: "col col-11 col-sm-6 col-md-6 text-center"
  }, [_c('SearchNoFoundIconComponent', {
    key: _vm.uniqueKeysHelper(),
    attrs: {
      "id": 4
    }
  }), _c('p', {
    staticClass: "text text-m-large-regular grey--text text--darken-1 mt-2"
  }, [_c('span', {
    staticClass: "text text-m-large-bold"
  }, [_vm._v("There’s no results matching your interests")]), _vm._v(". "), _vm.$vuetify.breakpoint.width >= 375 ? _c('br') : _vm._e(), _vm._v("Try searching using different words or just type another interest. ")])], 1)])]) : _vm._e()])], 1) : _vm._e()], 1)], 1)], 1), !_vm.loadingKeywords && !_vm.isFullScreenView ? _c('v-row', {
    staticClass: "sticky-actions-container px-6 pb-6 pt-sm-2 px-sm-10 pb-sm-10 justify-center d-flex",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-card', {
    staticClass: "actions-component-sticky",
    attrs: {
      "flat": ""
    }
  }, [_c('v-row', {
    attrs: {
      "justify": "center",
      "justify-sm": "end",
      "align": "center",
      "no-gutters": ""
    }
  }, [_c('div', {
    staticClass: "col-12 col-sm-auto mr-sm-4"
  }, [_c('v-btn', {
    staticClass: "primary--text heading heading-s-small align-self-center unaltered-text-cap letter-spacing-normal shadow-light-button px-6",
    attrs: {
      "ripple": "",
      "depressed": "",
      "block": "",
      "height": "44px",
      "color": "grey lighten-5"
    },
    on: {
      "click": _vm.skipKeywordsSelection
    }
  }, [_vm._v(" Do it later ")])], 1), _c('div', {
    staticClass: "col-12 col-sm-auto"
  }, [_c('v-btn', {
    staticClass: "heading heading-s-small text-capitalize px-7 white--text mb-4 mb-sm-0",
    attrs: {
      "disabled": _vm.currentSelectedKeywordsCount === 0,
      "ripple": "",
      "depressed": "",
      "block": "",
      "height": "44px",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.finishKeywordsSelection.apply(null, arguments);
      }
    }
  }, [_vm._v(" Continue ")])], 1)])], 1)], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }